<wtf-dialogcontent [size]="'md'" [dialogTitle]="dialogTitle" (closeModal)="dialogRef.close()" [action]="action">
    <form name="userForm" [formGroup]="userForm" class="tax-type-form w-100-p" fxLayout="column" fxFlex>
        <div fxLayout="row" fxLayoutAlign="end center">
            <mat-label>{{ "*Campos Obligatorios" | translate }}</mat-label>
        </div>
        <mat-label>{{ "Nombre de Usuario" | translate }}*</mat-label>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput name="Nombre de Usuario" formControlName="username" mat-maxlength="50" placeholder=""
                required />
        </mat-form-field>
        <mat-label>{{ "Primer Nombre" | translate }}*</mat-label>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput name="Primer Nombre" formControlName="firstName" mat-maxlength="50" placeholder=""
                required />
        </mat-form-field>
        <mat-label>{{ "Apellido" | translate }}*</mat-label>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput name="lastName" formControlName="lastName" mat-maxlength="50" placeholder="" required />
        </mat-form-field>
        <mat-label>{{ "Correo" | translate }}*</mat-label>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput name="email" formControlName="email" mat-maxlength="50" placeholder="" required />
        </mat-form-field>
        @if (isControlValid(userForm, "email")) {
        <div class="text-danger ng-mt-2">
            {{ getErrorMessage(userForm, "email", "Correo") }}
        </div>
        }
        <mat-label>{{ "Contraseña" | translate }}*</mat-label>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput type="password" (focus)="showPolicy()" autocomplete="off" (blur)="hidePolicy()"
                (input)="showPolicy()" name="password" formControlName="password" mat-maxlength="50" placeholder="" />
        </mat-form-field>
        @if (policy) {
        <div class="password-policy">
            <p>La contraseña debe cumplir con las siguientes políticas:</p>
            <ul>
                <li>Al menos 8 caracteres de longitud</li>
                <li>Incluir una letra mayúscula</li>
                <li>Incluir una letra minúscula</li>
                <li>Incluir un número</li>
                <li>{{"Incluir un carácter especial (@, #, $, etc.)"}}</li>
            </ul>
        </div>
        }

        <mat-checkbox class="" formControlName="has2FA">
            {{ "has2FA" | translate }}
        </mat-checkbox>

        <mat-label>{{ "Roles" | translate }}*</mat-label>
        <app-tag-input [maxItems]="1" [roles]="roles" [userRoles]="user.roles" [actionInput]="actionInput"
            (tagAddItem)="addItem($event)" (tagDeleteItem)="deleteItem($event)">
        </app-tag-input>
        <div fxLayout="row" fxLayoutAlign="end end">
            <button mat-raised-button (click)="saveUser()" class="submit-button" [disabled]="userForm.invalid"
                aria-label="Guardar">
                <span class="material-icons-outlined"> save </span>
                <span> {{ "Guardar" | translate }}</span>
            </button>
        </div>
    </form>
</wtf-dialogcontent>